import React from 'react';
import { useProgress } from '../contexts/ProgressContext';
import './SectionCheckbox.css';

const SectionCheckbox = ({ moduleId, sectionId, label }) => {
  const { isSectionCompleted, toggleSection } = useProgress();
  const isCompleted = isSectionCompleted(moduleId, sectionId);

  const handleToggle = () => {
    toggleSection(moduleId, sectionId);
  };

  return (
    <div
      className={`section-checkbox ${isCompleted ? 'completed' : ''}`}
      onClick={handleToggle}
    >
      <div className="checkbox-indicator">
        {isCompleted ? (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        ) : (
          <div className="checkbox-empty" />
        )}
      </div>
      <span className="checkbox-label">{label}</span>
    </div>
  );
};

export default SectionCheckbox;
